/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import { withSpectrumReact } from "components/shared/WithSpectrumReact";
import { AppHeader } from "components/shared/AppHeader";
import styled from "styled-components";
import { LogoMode } from "components/Logo";

const FullSizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
`;

const AppLayoutWrapper: React.FC<{ mode?: LogoMode }> = ({
  mode,
  children,
}) => {
  return (
    <div id="spectrum-Site-content">
      <AppHeader mode={mode} />
      <FullSizeContainer>{children}</FullSizeContainer>
    </div>
  );
};

export default withSpectrumReact(AppLayoutWrapper);
